import { apiClient } from "../../../config/netConfig";

/**
 * 获取管理员所属的所有角色及其权限
 * @param adminId 管理员ID
 */
export const getAdminRoles = async (adminId: string) => {
  console.log("=== adminPermissionService.getAdminRoles ===");
  console.log("请求参数:", { adminId });

  try {
    const response = await apiClient.get(`/admin/${adminId}/roles-with-permissions`);
    console.log("API响应成功:", response.data);
    return { data: response.data };
  } catch (error) {
    console.error("API调用失败:", error);
    throw error;
  }
};

/**
 * 获取管理员的额外权限（不包括来自角色的权限）
 * @param adminId 管理员ID
 */
export const getAdminExtraPermissions = async (adminId: string) => {
  console.log("=== adminPermissionService.getAdminExtraPermissions ===");
  console.log("请求参数:", { adminId });

  try {
    const response = await apiClient.get(`/admin/${adminId}/extra-permissions`);
    console.log("API响应成功:", response.data);
    return { data: response.data };
  } catch (error) {
    console.error("API调用失败:", error);
    throw error;
  }
};

/**
 * 保存管理员的额外权限
 * @param adminId 管理员ID
 * @param permissionIds 额外权限ID列表（只保存额外权限，不包括角色权限）
 */
export const saveAdminExtraPermissions = async (adminId: string, permissionIds: string[]) => {
  console.log("=== adminPermissionService.saveAdminExtraPermissions ===");
  console.log("请求参数:", { adminId, permissionIds });

  try {
    const response = await apiClient.post("/admin/assign-extra-permissions", {
      adminId,
      permissionIds,
    });
    console.log("API响应成功:", response.data);
    return { data: response.data };
  } catch (error) {
    console.error("API调用失败:", error);
    throw error;
  }
};

/**
 * 获取管理员的所有权限（角色权限 + 额外权限的并集）
 * @param adminId 管理员ID
 */
export const getAdminAllPermissions = async (adminId: string) => {
  console.log("=== adminPermissionService.getAdminAllPermissions ===");
  console.log("请求参数:", { adminId });

  try {
    const response = await apiClient.get(`/admin/${adminId}/all-permissions`);
    console.log("API响应成功:", response.data);
    return { data: response.data };
  } catch (error) {
    console.error("API调用失败:", error);
    throw error;
  }
};
